<template>
<div>
  <p class="title">
    Battery usage
    <span class="icon">
      <i v-if="loading" class="fas fa-circle-notch fa-spin"></i>
    </span>
  </p>
  <div class="tracker-selector level is-mobile">
    <p class="level-left is-size-4">Set Tracker:</p>
    <div>
      <select v-model="trackerId" @change="updateChart()">
        <option
          v-for="tracker in user.trackers"
          :key="tracker"
          :value="tracker"
        >{{tracker}}</option>
      </select>
      <br>
      <input v-model.number="amountOfPoints" @change="updateChart()" type="number" value="30" id="amountOfPoints" />
    </div>
  </div>
  <apexchart type="line" :options="options" :series="series"></apexchart>
</div>
</template>

<script>
export default {
  data: () => {
    return {
      trackerId: null,
      amountOfPoints: 30,
      loading: false,
      errorMessage: '',
      options: {
        colors: ['#00d1b2'],
        dataLabels: {
          enabled: false
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: {
          min: 0,
          max: 100
        }
      },
      series: []
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  methods: {
    async getPoints (amount, trackerId) {
      this.loading = true
      this.errorMessage = null
      // Fetch point from store/server
      const [error, pointCells] = await this.$store.dispatch('getLatestPoints', { amount, trackerId })
      this.loading = false
      if (error) {
        this.errorMessage = error
        return
      }
      return pointCells
    },
    async updateChart () {
      const amount = this.amountOfPoints
      const trackerId = this.trackerId
      const pointCells = await this.getPoints(amount, trackerId)

      const chartData = pointCells.map(pointCell => {
        if (!(pointCell && pointCell.battery && pointCell.created)) return null
        const timestamp = new Date(pointCell.created).getTime()
        return [timestamp, pointCell.battery.percentage]
      })
      this.series = [{
        data: chartData
      }]
    }
  },
  async created () {
    this.errorMessage = await this.$store.dispatch('getUser')
    if (this.user.trackers.length !== 0) this.trackerId = this.user.trackers[0]
    this.updateChart()
  }
}
</script>

<style scoped>
#amountOfPoints {
  width: 60px;
}
</style>
